const selectedAddressesToTree = (addressesArray, addressesTree) => {
	if (!addressesArray || !Object.keys(addressesArray).length) {
		return [];
	}
	const res = addressesTree
		.map((companyObj) => {
			const regions = companyObj.regions
				.map((regionObj) => {
					const streets = regionObj.streets
						.map((streetObj) => {
							const houses = streetObj.houses.filter((houseObj) => {
								return addressesArray[houseObj.houseId];
							});
							if (houses.length > 0) {
								return {
									...streetObj,
									houses,
								};
							}
						})
						.filter(Boolean);
					if (streets.length > 0) {
						return {
							...regionObj,
							streets,
						};
					}
				})
				.filter(Boolean);
			if (regions.length > 0) {
				return {
					...companyObj,
					regions,
				};
			}
		})
		.filter(Boolean);
	return res;
};
export default selectedAddressesToTree;
